import type { ResourceConfig } from "../types";

export const inClassTaskConfig = {
  displayName: "课堂任务",
  category: "in-class-task",
  permissions: {
    "read:all": {
      label: "访问课堂任务",
      description: "可以访问课堂任务功能（学员专用）",
    },
    "write:own": {
      label: "提交课堂作业",
      description: "可以提交自己的课堂任务答案和作业截图",
    },
  },
  // 学员任务页已外化至 workbench（/student-tasks → 302），CRM 不再持有导航项。
  // read:all / write:own 权限保留：workbench 的学员任务 handler 仍在使用。
} satisfies ResourceConfig;
